import { LOAD_CONTACT_CONTENT_FULFILLED } from "../actions/types";

const initialState = {
  loading: true,
  panelText: ""
};

export default function(state = initialState, action) {
  switch (action.type) {
    case LOAD_CONTACT_CONTENT_FULFILLED:
      return {
        ...state,
        panelText: action.payload.data["acf"]["message"],
        loading: false
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/contact-reducer.js